import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  AutomationReplacementChipsDataService,
  PagedResponse,
} from '../common/components/automation-replacement-chips/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class StaticSelectorService<T> implements AutomationReplacementChipsDataService<T> {
  supportsSearching = false;

  constructor(
    /**
     * choices is a pair of the value of the option and string to display
     *
     * You will supply this in the constructor of the service, like this:
     * choices = new Map<number, string>([
     *         [LifecycleStage.LIFECYCLE_STAGE_LEAD, 'AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.LEAD'],
     *         [LifecycleStage.LIFECYCLE_STAGE_PROSPECT, 'AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.PROSPECT'],
     *         [LifecycleStage.LIFECYCLE_STAGE_CUSTOMER, 'AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.CUSTOMER']
     *       ]);
     *
     * new StaticSelectorService(this.choices, this.translateService);
     *
     */
    private readonly choices: Map<T, string>,
    private readonly translateService: TranslateService,
  ) {}

  convertDataToDisplay(x: T): Observable<string> {
    if (!this.choices?.has(x)) {
      return of('');
    }
    return this.translateService.stream(this.choices.get(x) || '');
  }

  convertDataToFormValue(x: T): any {
    return x;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  doLookup(searchTerm: string, cursor: string, pageSize: number, extraData?: any): Observable<PagedResponse<T>> {
    return of(<PagedResponse<T>>{
      results: Array.from(this.choices.keys()),
      hasMore: false,
      nextCursor: cursor,
    });
  }

  getMulti(formValues: any[]): Observable<T[]> {
    return of(formValues);
  }
}
